import { DestroyRef, Directive, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { type ModuleConfig, type ModuleConfigState, type ModuleId, type ModuleResult } from '@pixacare/forms';
import { ModuleResolverInputs } from '../models/module-resolver-inputs';
import { ModuleResolverService } from '../services/module-resolver.service';

@Directive()
export abstract class FormTriggerBase {
  readonly targetId = input.required<string>();
  readonly modules = input.required<ModuleConfigState[]>();
  readonly moduleInputs = input.required<ModuleResolverInputs>();

  readonly moduleTriggered = output<{ moduleId: ModuleId; targetId: string; result: ModuleResult }>();
  readonly moduleReset = output<{ moduleId: ModuleId; targetId: string }>();

  protected readonly moduleResolver = inject(ModuleResolverService);
  private readonly destroyRef = inject(DestroyRef);

  triggerModule(module: ModuleConfig): void {
    this.moduleResolver
      .resolve(module.moduleId, this.moduleInputs())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (result) => {
          this.moduleTriggered.emit({
            moduleId: module.moduleId,
            targetId: this.targetId(),
            result,
          });
        },
      });
  }

  resetModule(module: ModuleConfig): void {
    this.moduleReset.emit({
      moduleId: module.moduleId,
      targetId: this.targetId(),
    });
  }
}
